module.exports = __webpack_public_path__ + "media/images/shared/about_live/talkport/ogp-3a4016865e6ed296cb754b469f7e4b65.png";